// Date 2023-06-26 13:00:19

import sithMesAgreement from "@/store/sithMes/agreement/SithMesAgreementStore.js";

const genericEntities = [
    'sithMesAgreement',
]

const entities = {
    sithMesAgreement,
}

export {genericEntities}

export default entities
